// Contact, social and legal details migrated from the previous site (superluxury.io).

export const contact = {
  email: 'hey@superluxury.io',
  phoneDisplay: '+971 50 525 4282',
  phoneHref: 'tel:+971505254282',
  whatsappNumber: '971505254282',
  supportLanguage: 'English',
  domain: 'superluxury.io',
};

export type SocialProfile = {
  label: string;
  username: string;
  handle: string;
  href: string;
  // Word shown under the monogram when no picture is uploaded (e.g. "CLUB")
  crestLabel?: string;
  // Short line on what the channel shows
  focus: string;
  // Public figures from the profile — leave undefined until confirmed, nothing is shown then
  followers?: string;
  posts?: string;
  bio?: string;
  verified?: boolean;
  // Profile picture URL (upload the image and paste its link). Without it, the house crest is drawn.
  avatar?: string;
};

// Instagram accounts of the house.
// @superluxurymedia figures are from its public profile (Oct 2026: 1,079,971 followers, 7,458 posts).
// The other three profiles could not be read publicly — add their follower and post counts here once confirmed.
export const socialProfiles: SocialProfile[] = [
  {
    label: 'Superluxury Media',
    username: 'superluxurymedia',
    handle: '@superluxurymedia',
    href: 'https://www.instagram.com/superluxurymedia/',
    focus: 'Residences, hotels, yachts and the moments in between',
    followers: '1M',
    posts: '7,458',
    bio: 'SUPERLUXURY.IO | Selected Assets. Dubai — to the world. Media • Concierge • Strategic Access.',
    avatar: 'https://cdn.magicpatterns.com/uploads/aZpx1Ns7M91bBESbR1BkAn/SL_Media_Profile.png',
  },
  {
    label: 'Superluxury Retreats',
    username: 'superluxuryretreats',
    handle: '@superluxuryretreats',
    href: 'https://www.instagram.com/superluxuryretreats/',
    focus: 'Hideaways, wellness and private estates',
    avatar: 'https://cdn.magicpatterns.com/uploads/qnQA5Bk32pmbCL4TZsaE1v/SL_retrreats_Profile.png',
  },
  {
    label: 'Superluxury Dubai',
    username: 'superluxury.dubai',
    handle: '@superluxury.dubai',
    href: 'https://www.instagram.com/superluxury.dubai?dlrf=MW9ncGM2c3lkaWhtcA==',
    focus: 'Penthouses, the marina and the desert',
    avatar: 'https://cdn.magicpatterns.com/uploads/ebETgKxwWiaNM7XTR1Cjba/SL_dubai_Profile.png',
  },
  {
    label: 'Superluxury Mallorca',
    username: 'superluxurymallorca',
    handle: '@superluxurymallorca',
    href: 'https://www.instagram.com/superluxurymallorca/',
    focus: 'Fincas, calas and island summers',
    avatar: 'https://cdn.magicpatterns.com/uploads/x7pQkhBrpCaw7nt8sjJXUe/SL_mallorca_Profile.png',
  },
  {
    // Instagram handle not yet confirmed — links to the SL Club page on this site until it is.
    label: 'SL Club',
    username: 'slclub',
    handle: 'Members’ circle',
    href: '/sl-club',
    focus: 'Private evenings and closed-door occasions',
    crestLabel: 'CLUB',
    avatar: 'https://cdn.magicpatterns.com/uploads/qEn1uT8CNZrCqx1QPnUzXi/LAEBEL_LABS_BRANDS_LOGOTYPES-27.png',
  },
];

// Legal documents — served as subpages of this site (content in data/legal.ts).
export const legalLinks = {
  privacyPolicy: '/privacy-policy',
  cookiePolicy: '/cookie-policy',
  legalNotice: '/imprint',
};

export const cookieConsent = {
  thirdPartyCount: 6,
  storageKey: 'sl-cookie-consent',
};
